<template>
    <div class="lft-view report-side-panel q-box-shadow">
        <report-header @updateEvent="updateTurnover" @downloadEvent="exportExcel"/>
        <!-- table set -->
        <div class="table-wrapper" ref="tableWrapperLap">
            <div class="master-table-head-box">
                <div class="master-table-head customer-turnover">
                    <div class="customer-w dropdown-setter left-pos-cell" data-setter="customer">
                        <div class="master-table-text left-table-header" @click="sortTable('customer')">Customer</div>
                        <div class="master-table-opt"></div>
                        <button type="button" class="vs-con-dropdown parent-dropdown" data-getter="customer">
                            <a href.prevent class="a-icon">
                                <i :class="(customerSearch.length > 0)?'filter-icon-i-active':'filter-icon-i'"></i>
                                <!-- <i class="vs-icon notranslate icon-scale more-vert-24px material-icons null"></i> -->
                            </a>
                        </button>
                        <dropdown>
                            <ul>
                                <li>
                                    <input oninput="this.value = this.value.replace(/[-!$%^*_+@\s|~=`\\#{}\[\]:;'<>?,.\/]/g,'')"
                                    type="text" class="dropdown-input" placeholder="Search"
                                           v-model="customerSearch"/>
                                </li>
                            </ul>
                        </dropdown>
                    </div>
                    <div class="co-w-thone dropdown-setter right-pos-cell" data-setter="CustomerOE">
                        <div class="master-table-text left-table-header" @click="sortTable('CustomerOE')">OE</div>
                        <div class="master-table-opt"></div>
                        <button type="button" class="vs-con-dropdown parent-dropdown" data-getter="CustomerOE">
                            <a href.prevent class="a-icon">
                                <i :class="(oeSearch.length > 0)?'filter-icon-i-active':'filter-icon-i'"></i>
                                <!-- <i class="vs-icon notranslate icon-scale more-vert-24px material-icons null"></i> -->
                            </a>
                        </button>
                        <dropdown>
                            <ul>
                                <li>
                                    <input oninput="this.value = this.value.replace(/[-!$%^*_+@\s|~=`\\#{}\[\]:;'<>?,.\/]/g,'')"
                                    type="text" class="dropdown-input" placeholder="Search" v-model="oeSearch"/>
                                </li>
                            </ul>
                        </dropdown>
                    </div>
                </div>
            </div>
            <div class="master-table vb" :class="loaderClass" v-bar>
                <scroll-sync group="report" vertical>
                    <!-- add here -->
                    <template v-for="(relation, index) in relations">
                        <div class="report-left-list customer-turnover" :key="index" ref="turnoverRelationRow">
                            <div class="each-turn customer-w">
                                <div class="master-table-text right-table-header alloc-value">
                                    <p class="left-td">{{relation.customerName}}</p>
                                </div>
                            </div>
                            <div class="each-turn co-w-thone">
                                <div class="master-table-text right-table-header alloc-value">
                                    <p class="left-td">{{relation.shortName}}</p>
                                </div>
                            </div>
                        </div>
                    </template>
                    <div class="no-item" v-if="relations.length < 1">No items found !</div>
                </scroll-sync>
            </div>
        </div>
        <!-- bottom -->
        <div class="table-results">
            <div class="table-result">
                <p class="left-td bottom-left-heading">Total</p>
            </div>
        </div>
    </div>
</template>

<script>
    import settings from "../../../../config/settings";

    const ReportHeader = () => import("../ReportHeader");
    const Dropdown = () => import("../../../common/Dropdown");
    import _ from "lodash";
    import searchKeys from "../../../../config/searchKeys";

    export default {
        name: "CustomerTurnoverRelation",
        components: {ReportHeader, Dropdown},
        data: () => {
            return {
                loaderClass: ""
            };
        },
        computed: {
            /**
             * Customer turnover relation
             */
            relations: function () {
                return this.$store.state.reports.customerTurnoverRelations;
            },

            /**
             * Customer turnover filter
             */
            filter: function () {
                return this.$store.state.reports.customerTurnoverFilter;
            },
            customerSearch: {
                get: function () {
                    // get the filters array from the store
                    let filters = this.$store.state.reports.customerTurnoverFilter.filterParams;
                    // get the current filter by matching the field name
                    let currentFilterObject = filters.find(
                        f => f.fieldName === searchKeys.customer
                    );
                    // if the filter exists, then return the value else empty
                    return currentFilterObject ? currentFilterObject.value : "";
                },
                set: function (value) {
                    let data = {
                        key: searchKeys.customer,
                        value: value
                    };
                    this.$store.commit("setCustomerTurnoverSearchData", data);
                }
            },
            oeSearch: {
                get: function () {
                    // get the filters array from the store
                    let filters = this.$store.state.reports.customerTurnoverFilter.filterParams;
                    // get the current filter by matching the field name
                    let currentFilterObject = filters.find(
                        f => f.fieldName === searchKeys.CustomerOE
                    );
                    // if the filter exists, then return the value else empty
                    return currentFilterObject ? currentFilterObject.value : "";
                },
                set: function (value) {
                    let data = {
                        key: searchKeys.CustomerOE,
                        value: value
                    };
                    this.$store.commit("setCustomerTurnoverSearchData", data);
                }
            }
        },
        updated() {
            // update the loader on changing the component
            this.updateLoader();
        },
        methods: {
            /**
             * Update the loader by adding class
             * Check if the row if visible in the dom
             */
            updateLoader: function () {
                setTimeout(() => {
                    this.loaderClass =
                        this.$refs.turnoverRelationRow &&
                        this.$refs.turnoverRelationRow.length > 0
                            ? "master-table-loaded"
                            : "";
                }, 200);
            },
            /**
             * Refetch the current turnover data
             */
            updateTurnover: function () {
                let filter = _.cloneDeep(this.filter);
                filter.pageNumber = 1;
                filter.pageSize =
                    this.relations &&
                    this.relations.length &&
                    this.relations.length > settings.initial_forecast_row_count
                        ? this.relations.length
                        : settings.initial_forecast_row_count;
                this.$store.dispatch("fetchCustomerTurnoverReport", filter);
                this.$store.dispatch("fetchReportAggregates", filter);
            },
            exportExcel: function () {
                let filter = _.cloneDeep(this.filter);
                filter.pageNumber = 1;
                filter.pageSize =
                    this.relations &&
                    this.relations.length &&
                    this.relations.length > settings.initial_forecast_row_count
                        ? this.relations.length
                        : settings.initial_forecast_row_count;
                // send request
                this.$store.dispatch("exportCustomerTurnover", filter);
            },
            /**
             * Sort the table on click
             */
            sortTable: function (column) {
                let rowCount = settings.initial_forecast_row_count;
                //clone the filter
                let filter = this.filter;
                let filterData = _.cloneDeep(filter);
                // if no sort set or sort set for another column
                if (!filter.sortColumn || filter.sortColumn !== searchKeys[column]) {
                    this.$store.commit("setCustomerTurnoverSort", {
                        column: searchKeys[column],
                        order: "ASC"
                    });
                    filterData.sortColumn = searchKeys[column];
                    filterData.sortOrder = 'ASC';
                } else if (filter.sortColumn === searchKeys[column] && filter.sortOrder === "ASC") {
                    this.$store.commit("setCustomerTurnoverSort", {
                        column: searchKeys[column],
                        order: "DESC"
                    });
                    filterData.sortColumn = searchKeys[column];
                    filterData.sortOrder = 'DESC';
                } else if (filter.sortColumn === searchKeys[column] &&filter.sortOrder === "DESC") {
                    this.$store.commit("setCustomerTurnoverSort", {
                        column: searchKeys[column],
                        order: "ASC"
                    });
					filterData.sortColumn = searchKeys[column];
					filterData.sortOrder = 'ASC';
                }
                if (
                    this.relations &&
                    this.relations.length &&
                    this.relations.length > settings.initial_forecast_row_count
                ) {
                    rowCount = this.relations.length;
                }

                // set row count
                filterData.pageSize = rowCount;
                // set the page number to 1
                filterData.pageNumber = 1;
                // request data with filter
                this.$store.dispatch("fetchCustomerTurnoverReport", filterData);
            },
            /**
             * Submit the search result for customer turnover
             */
            submitSearchResult: function () {
                let filter = _.cloneDeep(this.filter);
                filter.pageNumber = 1;
                filter.pageSize = settings.initial_forecast_row_count;
                clearTimeout(this.timeout);
                this.timeout = setTimeout(() => {
                    // fetch the bench report with the search data
                    this.$store.dispatch("fetchCustomerTurnoverReport", filter);
                    this.$store.dispatch("fetchReportAggregates", filter);
                }, 700);
            },
            
              wrappingLap: function(){
                // this.$refs.table-wrapper-lap
                var el = this.$refs.tableWrapperLap;
                if(!el.closest('.table-wrapper-outer')){
                    
                    var wrapper = document.createElement('div');
                    wrapper.classList.add('table-wrapper-outer');
                    el.parentNode.insertBefore(wrapper, el);
                    wrapper.appendChild(el);
                }
            }
        },
        mounted(){
            this.wrappingLap();
        },
        watch: {
            customerSearch: function (value) {
                if (!value || !/^\s+$/.test(value)) {
                    this.submitSearchResult();
                }
            },
            oeSearch: function (value) {
                if (!value || !/^\s+$/.test(value)) {
                    this.submitSearchResult();
                }
            }
        }
    };
</script>

<style scoped>
    .table-results {
        /* padding-top: 0; */
    }

    .each-turn p {
        /* old code */
        /* padding: 22px 0; */
        /* padding: 7px 0; */
    }

    .customer-turnover {
        border-bottom: 1px solid #dee1e3;
    }

    /* Master table on Customer turnover  */
    .master-table {
        height: calc(100vh - 251px);
        max-height: calc(100vh - 251px);
        min-height: calc(100vh - 251px);
        border-bottom: 1px solid #dee1e3;
    }

    .table-result:first-child .bottom-left-heading {
        /* padding-top: 16px; */
    }
</style>